import { ApiRoute } from 'api-base-refrence';
import { InformationApiRoute } from './information.api';

export class ChartMonetaryProvinceApiRoute extends ApiRoute {
  static apiName = '';
  static parent = InformationApiRoute;
  static urlPattern() {
    return `/chart-monetary-province`;
  }
}
